import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const BulkApprovalModal = ({ selectedCount, onConfirm, onClose }) => {
  const [action, setAction] = useState('approve');

  return (
    <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50 p-4">
      <div className="bg-slate-900 border border-slate-700 rounded-xl w-full max-w-md">
        {/* Header */}
        <div className="bg-slate-800 border-b border-slate-700 px-6 py-4 flex items-center justify-between rounded-t-xl">
          <div className="flex items-center space-x-3">
            <div className="w-10 h-10 rounded-lg bg-amber-500/20 flex items-center justify-center">
              <Icon name="CheckSquare" size={24} color="#F59E0B" />
            </div>
            <div>
              <h2 className="text-lg font-bold text-white font-heading">Bulk Action</h2>
              <p className="text-sm text-slate-400 font-body">{selectedCount} requests selected</p>
            </div>
          </div>
          <button
            onClick={onClose}
            className="p-2 rounded-lg hover:bg-slate-700 transition-colors"
          >
            <Icon name="X" size={20} color="#94A3B8" />
          </button>
        </div>

        {/* Content */}
        <div className="p-6 space-y-4">
          <div>
            <label className="block text-sm font-medium text-slate-300 mb-3 font-body">
              Select Action
            </label>
            <div className="space-y-2">
              <label className="flex items-center space-x-3 p-3 bg-slate-800 border border-slate-700 rounded-lg cursor-pointer hover:bg-slate-700 transition-colors">
                <input
                  type="radio"
                  name="bulkAction"
                  value="approve"
                  checked={action === 'approve'}
                  onChange={(e) => setAction(e?.target?.value)}
                  className="w-4 h-4 text-green-500 focus:ring-green-500"
                />
                <div className="flex items-center space-x-2">
                  <Icon name="CheckCircle" size={20} color="#4ADE80" />
                  <div>
                    <p className="text-sm font-medium text-white font-body">Approve All</p>
                    <p className="text-xs text-slate-400 font-caption">Process full refund for all selected requests</p>
                  </div>
                </div>
              </label>
              <label className="flex items-center space-x-3 p-3 bg-slate-800 border border-slate-700 rounded-lg cursor-pointer hover:bg-slate-700 transition-colors">
                <input
                  type="radio"
                  name="bulkAction"
                  value="reject"
                  checked={action === 'reject'}
                  onChange={(e) => setAction(e?.target?.value)}
                  className="w-4 h-4 text-red-500 focus:ring-red-500"
                />
                <div className="flex items-center space-x-2">
                  <Icon name="XCircle" size={20} color="#F87171" />
                  <div>
                    <p className="text-sm font-medium text-white font-body">Reject All</p>
                    <p className="text-xs text-slate-400 font-caption">Reject all selected refund requests</p>
                  </div>
                </div>
              </label>
            </div>
          </div>

          {/* Warning */}
          <div className={`flex items-start space-x-3 p-3 rounded-lg border ${
            action === 'approve' ? 'bg-green-500/10 border-green-500/30' : 'bg-red-500/10 border-red-500/30'
          }`}>
            <Icon name="AlertTriangle" size={20} color={action === 'approve' ? '#4ADE80' : '#F87171'} />
            <div>
              <p className="text-sm font-medium text-white font-body mb-1">
                {action === 'approve' ? 'Bulk Approval' : 'Bulk Rejection'}
              </p>
              <p className="text-xs text-slate-300 font-caption">
                This will {action === 'approve' ? 'approve' : 'reject'} {selectedCount} refund request{selectedCount > 1 ? 's' : ''}. This action cannot be undone.
              </p>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="bg-slate-800 border-t border-slate-700 px-6 py-4 flex items-center justify-end space-x-3 rounded-b-xl">
          <Button onClick={onClose} variant="outline">
            Cancel
          </Button>
          <Button
            onClick={() => onConfirm(action)}
            className={action === 'approve' ? 'bg-green-500 hover:bg-green-600' : 'bg-red-500 hover:bg-red-600'}
          >
            <Icon name={action === 'approve' ? 'CheckCircle' : 'XCircle'} size={18} />
            <span className="ml-2">{action === 'approve' ? 'Approve' : 'Reject'} {selectedCount} Request{selectedCount > 1 ? 's' : ''}</span>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default BulkApprovalModal;